<template>
	<section id="homeCarousel" class="carousel slide carousel-fade" data-ride="carousel">
		<ol class="carousel-indicators">
			<li v-for="(slide, index) in slides"
				:key="index"
				data-target="#homeCarousel"
				:data-slide-to="index"
				:class="index === 0 ? 'active' : ''" />
		</ol>
		<div class="carousel-inner">
			<div
				v-for="(slide, index) in slides"
				:key="index"
				:class="index === 0 ? 'carousel-item active' : 'carousel-item'"
			>
				<img :src="slide.backgroundImage" class="bd-placeholder-img bd-placeholder-img-lg d-block" />
				<div class="container">
					<div :class="'carousel-caption text-start ' + (slide.isBackgroundLight ? 'text-dark' : 'text-white')">
						<h3 v-if="slide.headline.length > 0" v-html="slide.headline"></h3>
						<p v-if="slide.copy.length > 0" v-html="slide.copy"></p>
						<h-button v-if="slide.ctaUrl != ''"
								  :is-white="!slide.isBackgroundLight"
								  :url="slide.ctaUrl">
							{{slide.ctaText}}
						</h-button>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>


<script>
	import HButton from '../components/HButton.vue';
	
	export default {
		components: {
			HButton
		},
		data() {
			return {
				autoplayInterval: null,
				currentSlide: 0,
				autoplayProgress: 0.0,
				isPaused: false,
				slides: []
			}
		},
		props: {
			carouselId: {
				type: String,
				default: ''
			},
			cultureCode: {
				type: String,
				default: "en-US"
			},
			autoSlideDelay: {
				type: Number,
				default: 7000.0
			},
			includeNavBar: {
				type: Boolean,
				default: false,
			},
			navHeading: {
				type: String,
				default: ''
			}
		},
		mounted() {
			this.$axios.get(this.cultureCode.toLowerCase() + '/slideshow/' + this.carouselId.toLowerCase())
				.then((response) => {
					this.slides = response.data.slides;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		methods: {
		}
	}
</script>


<style lang="scss">
	#homeCarousel {
		.carousel-item {
			height: 500px;

			.carousel-caption {
				left: 4%;
				bottom: 100px;
				text-align: left;

				h3 {
					line-height: normal;
					padding-bottom: 1.25rem;
					font-size: 2.5rem;
					font-style: normal;
					font-weight: 400;
				}

				@include respond-below(lg) {
					br {
						display: none;
					}
				}
			}
		}
		.carousel-indicators li {
			width: 180px;
		}
	}
</style>
